import MetabaseDashboard from '@/modules/metabase/pages/MetabaseDashboard'
import MetabaseDashboardList from '@/modules/metabase/pages/MetabaseDashboardList'
import MetabaseComputationsPage from '../pages/MetabaseComputationsPage'
import MetabasePage from '../pages/MetabasePage'
import MetabaseProjectPage from '../pages/MetabaseProjectPage'

export default [
  {
    name: 'MetabaseApplication',
    path: '/metabase',
    component: MetabasePage,
    meta: {
      project: false
    }
  },
  {
    name: 'MetabaseProjectApplication',
    path: '/metabase/project',
    component: MetabaseProjectPage
  },
  {
    name: 'MetabaseDashboard',
    path: '/metabase/dashboard',
    component: MetabaseDashboard
  },
  {
    name: 'MetabaseDashboardList',
    path: '/metabase/dashboards',
    component: MetabaseDashboardList,
    meta: {
      title: 'Metabase_MetabaseDashboardListPage_Title'
    }
  },
  {
    name: 'MetabaseComputationList',
    path: '/metabase/computations',
    component: MetabaseComputationsPage,
    meta: {
      auth: ['MetabaseComputation:ReadAccess'],
      title: 'Metabase_MetabaseComputationListPage_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/metabase/router/index.js